import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-python-odoo-dev',
  templateUrl: './custom-python-odoo-dev.component.html',
  styleUrls: ['./custom-python-odoo-dev.component.css']
})
export class CustomPythonOdooDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/custom-python-odoo-dev/custom-python-odoo-dev.component.ts